import React, { useState } from "react";
import { Image } from "react-bootstrap";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import MessageIcon from "../../assets/message-icon.svg"; // right panel icon
import MailIcon from "../../assets/mail-icon.svg";
import { LoaderPage } from "../../component/Loader";
// import FeedBack_banner from "../../assets/Feedback banner.svg";
import FeedBack_banner from "../../assets/New_banner.svg";
import Bullet from "../../assets/Bullet.svg";
import Feedback_Breadcrumb from "../../assets/Feedback_Breadcrumb.svg";
import { successToastStyle, errorToastStyle } from "../../customToast";
import { PATHS } from "../../constant";
const initialForm = { fullName: "", mobile: "", email: "", message: "" };
const tips = [
  "Tell us which page or feature your feedback relates to.",
  "Describe what worked well or what could be improved.",
  "For suggestions, explain the change you would like to see."
];
const FeedBackAndSuggestions = () => {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = e => {
    const { name, value } = e.target;
    // allow only digits in mobile, max 10
    const val =
      name === "mobile" ? value.replace(/\D/g, "").slice(0, 10) : value;
    setForm(prev => ({ ...prev, [name]: val }));
    setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const err = {};
    if (!form.fullName.trim()) err.fullName = "Full name is required";
    if (!/^[6-9]\d{9}$/.test(form.mobile))
      err.mobile = "Enter a valid 10-digit mobile number";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      err.email = "Enter a valid email address";
    if (!form.message.trim()) err.message = "Message is required";
    return err;
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const err = validate();
    if (Object.keys(err).length) {
      setErrors(err);
      toast.error(
        <p className="toast-text-alignment">Mandatory Fields Are Missing</p>,
        { ...errorToastStyle, toastId: "feedback-error" }
      );
      return;
    }

    if (loading) return; // block double submit

    setLoading(true);
    try {
      // TODO: replace with your API call
      // await submitFeedback(form);
      console.log("Submitting:", form);

      // keep the loader visible for 1 second
      await new Promise(resolve => setTimeout(resolve, 1000));

      setLoading(false);
      toast.success(
        <p className="toast-text-alignment">
          Thank you! Your feedback has been submitted successfully.
        </p>,
        successToastStyle
      );
      setForm(initialForm);
      setErrors({});
    } catch (error) {
      setLoading(false);
      toast.error(
        <p className="toast-text-alignment">
          Something went wrong. Please try again.
        </p>,
        errorToastStyle
      );
    }
  };

  return (
    <div className="about-us-container">
      <LoaderPage loading={loading} />
      {/* <Image src={Feedback_Breadcrumb} />
      <Image src={FeedBack_banner} /> */}

      {/* Breadcrumb */}
      <nav aria-label="breadcrumb" className="page-breadcrumb">
        <ol>
          <li>
            <li className="crumb-home">Home</li>
          </li>
          <li className="active" aria-current="page">
            Feedback &amp; Suggestions
          </li>
        </ol>
      </nav>

      {/* Banner */}
      <div className="page-banner">
        <Image src={FeedBack_banner} alt="" className="page-banner-img" />
        <h1 className="page-banner-title">Feedback &amp; Suggestions</h1>
      </div>
      <section className="feedback-section">
        <div className="feedback-heading">
          <h2>We value your feedback</h2>
          <p>
            Share your experience or suggest how we can improve the PMG website.
          </p>
        </div>

        <div className="feedback-grid">
          {/* Left: Form */}
          <form
            className="feedback-card-homepage"
            onSubmit={handleSubmit}
            noValidate
          >
            <div className="feedback-card-header">
              <h3>Share your thoughts</h3>
              <span className="required-note">
                <span className="req">*</span> Required fields
              </span>
            </div>

            <div className="feedback-form-group">
              <label htmlFor="fullName">
                Full Name<span className="req">*</span>
              </label>
              <input
                id="fullName"
                name="fullName"
                type="text"
                placeholder="Full Name"
                value={form.fullName}
                onChange={handleChange}
                className={errors.fullName ? "invalid" : ""}
              />
              {errors.fullName && (
                <small className="feedback-error">{errors.fullName}</small>
              )}
            </div>

            <div className="feedback-form-group">
              <label htmlFor="mobile">
                Mobile Number<span className="req">*</span>
              </label>
              <div className="input-group-custom">
                <span className="prefix">+ 91</span>
                <input
                  id="mobile"
                  name="mobile"
                  type="tel"
                  inputMode="numeric"
                  placeholder="10-digit Mobile Number"
                  value={form.mobile}
                  onChange={handleChange}
                  className={errors.mobile ? "invalid" : ""}
                />
              </div>
              {errors.mobile && (
                <small className="feedback-error">{errors.mobile}</small>
              )}
            </div>

            <div className="feedback-form-group">
              <label htmlFor="email">
                Official E-mail ID<span className="req">*</span>
              </label>
              <div className="input-with-icon">
                <img src={MailIcon} alt="" className="input-icon" />
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="example@gmail.com"
                  value={form.email}
                  onChange={handleChange}
                  className={errors.email ? "invalid" : ""}
                />
              </div>
              {errors.email && (
                <small className="feedback-error">{errors.email}</small>
              )}
            </div>

            <div className="feedback-form-group">
              <label htmlFor="message">
                Your message<span className="req">*</span>
              </label>
              <textarea
                id="message"
                name="message"
                rows={4}
                placeholder="Tell us about your experience or describe your suggestion..."
                value={form.message}
                onChange={handleChange}
                className={errors.message ? "invalid" : ""}
              />
              {errors.message && (
                <small className="feedback-error">{errors.message}</small>
              )}
            </div>

            <div className="form-actions">
              <button type="submit" className="feedback-submit-btn">
                SUBMIT FEEDBACK
              </button>
            </div>
          </form>

          {/* Right: Help panel */}
          <aside className="help-card">
            <Image src={MessageIcon} alt="" className="help-icon" />
            <h3>Help us improve</h3>
            <p>
              Your ideas can help make the PMG Portal clearer and easier to use.
            </p>

            <ul>
              {tips.map(tip => (
                <li key={tip}>
                  <Image src={Bullet} alt="" className="bullet-icon" />
                  <span>{tip}</span>
                </li>
              ))}
            </ul>

            <hr />

            <h4>Need assistance?</h4>
            <Link to={PATHS.CONTACT_US_PAGE} className="contact-link">
              View contact details →
            </Link>
          </aside>
        </div>
      </section>
    </div>
  );
};

export default FeedBackAndSuggestions;
